import eventClock, {
  isWXTemplate,
  WEAPP
} from '../../../../../page-resource/lesson/compoents/clock/event'
import clockTpl from '../../../../../page-resource/lesson/compoents/clock/tpl'
import { clockTemplate } from './tpl'
import { appToWeapp, wxToWeapp } from './weappEvent'
import clockStyle from './wxStyle'
export function clockInit() {
  eventClock('.wxOpenInWeapp > a', appToWeapp)
}
export function renderWXClockTpl() {
  if (!isWXTemplate() && window.baseInfo.is_join == '1') {
    clockTpl(WEAPP, clockTemplate, clockStyle, wxToWeapp)
  }
}



// WEBPACK FOOTER //
// ./src/pages/lesson/play/components/clock/index.js